<script lang="ts">
  import { link } from "svelte-spa-router";
  import { CATEGORIES } from "../categories";
  import { entries, activeCategories } from "../content";
  import type { SopCategory } from "../types";

  /** Currently selected category id, or null for "All". */
  export let active: SopCategory | "all" | "favourites" = "all";

  $: present = activeCategories($entries);
  $: cats = CATEGORIES.filter((c) => present.includes(c.id)).sort((a, b) => a.order - b.order);
</script>

<div class="flex flex-wrap items-center gap-2">
  <a
    use:link
    href="/"
    class="pill"
    class:pill-active={active === "all"}
    class:text-text-muted={active !== "all"}
  >
    All
  </a>
  <a
    use:link
    href="/category/favourites"
    class="pill"
    class:pill-active={active === "favourites"}
    class:text-text-muted={active !== "favourites"}
  >
    ★ Favourites
  </a>
  {#each cats as cat}
    {@const href = `/category/${cat.id}`}
    <a
      use:link
      {href}
      class="pill"
      class:pill-active={active === cat.id}
      class:text-text-muted={active !== cat.id}
    >
      {cat.label}
    </a>
  {/each}
</div>
